import React, { useContext, useState } from "react";
import {
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router-dom";

import { Workflow } from "@contractool/schema/Workflow";

import { AuthContext } from "@/utils/auth";
import { Page } from "@/components/ui/Layout/Page";
import { Search } from "@/components/ui/Input/Search";
import Roles from "@/components/Workflow/Roles/Roles";
import Grids from "@/components/Workflow/Grids/Grids";
import Fields from "@/components/Workflow/Fields/Fields";
import { Tab, Tabs } from "@/components/ui/Navigation/Tabs";

export function WorkflowPage() {
  const { config } = useContext(AuthContext);

  const { id } = useParams<{ id: string }>();

  const { path } = useRouteMatch();

  const [search, setSearch] = useState("");

  const workflow = config?.workflows?.find(
    (workflow: Workflow) => workflow.id === Number(id)
  );

  const searchField = (phrase: string) => {
    setSearch(phrase);
  };

  return (
    <Page>
      <h1 className="text-lg leading-tight select-none mb-5 text-gray-800 text-left">
        Workflow - <span className="font-bold">{workflow?.label}</span>
      </h1>
      <Search
        onChange={searchField}
        placeholder={"Filter properties..."}
        value={search}
      />
      <Tabs>
        <Tab className="py-8" heading="Fields" name="fields">
          <Fields fields={workflow?.fields?.meta_data} search={search} />
        </Tab>

        <Tab className="py-8" heading="Roles" name="roles">
          <Roles
            roles={workflow?.roles}
            search={search}
            supplierFields={config?.supplier_fields?.map((item) => {
              return {
                id: item.name,
                name: item.name,
                key: "supplier.fields." + item.name,
              };
            })}
            supplierPOCFields={config?.supplier_poc_fields?.map((item) => {
              return {
                id: item.name,
                name: item.name,
                key: "supplierContact.fields." + item.name,
              };
            })}
          />
        </Tab>
        <Tab className="py-8" heading="Grids" name="grids">
          <Grids grids={workflow?.fields?.grids} search={search} />
        </Tab>
      </Tabs>
    </Page>
  );
}
